<template>
    <div class="body">

        <header class="header">
            <nav>
                <div class="leftnav">

                    <li class="nav-item" v-on:click="menuClose"><a><router-link to="/lobby"><img :src="headerlogo" class="headerlogo" alt="veeamlogo"></router-link></a></li>

                    <ul class="mainmenu">
        
                        <li class="nav-item"><a><router-link to="/agenda">Sessions</router-link></a></li>
                        <li class="nav-item"><a><router-link to="/speakers">Speakers</router-link></a></li>
                        <!--<li class="nav-item"><a :href="'https://veeambooth.com/veeamlive/?userId='+ticketNumber+'&domain=veeamlive.com'" target="_blank">Veeam Booth</a></li>-->
                        <li class="nav-item"><a><router-link to="/community">Community</router-link></a></li>
                        <li class="nav-item"><a><router-link to="">Engage</router-link></a>

                            <ul class="dropdown">
                                <!--<li class="nav-item"><a><router-link to="/trivia">Trivia</router-link></a></li>
                                <li class="nav-item"><a><router-link to="/socialwall">Social Wall</router-link></a></li>-->
                                <li class="nav-item"><a><router-link to="/eventsurvey">Event Survey</router-link></a></li>
                            </ul>

                        </li>
                        
                        <li class="nav-item"><a><router-link to="">Resource Center</router-link></a>
                        
                            <ul class="dropdown">
                                <li class="nav-item"><a id='myLauncher' @click="zeTrigger"><router-link to="">Help Desk</router-link></a></li>
                                <li class="nav-item"><a><router-link to="/FAQ">FAQ</router-link></a></li>
                            </ul>
                        
                        </li>

                        <!-- PARTH!! -->
                        <li class="nav-item"><a @click="logout">Logout</a></li>
                        
                    </ul>
                </div>

                <div id="menuToggle">
                    <input type="checkbox" v-on:click="menuTrigger" />
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

            </nav>
        </header>

        <ul id="mobilemenu">
            <div class="mobilelist">
                <li class="nav-item" v-on:click="menuClose"><a><router-link to="/agenda">Sessions</router-link></a></li>
                <li class="nav-item" v-on:click="menuClose"><a><router-link to="/speakers">Speakers</router-link></a></li>
                <!--<li class="nav-item" v-on:click="menuClose"><a :href="'https://veeambooth.com/veeamlive/?userId='+ticketNumber+'&domain=veeamlive.com'" target="_blank">Veeam Booth</a></li>-->
                <li class="nav-item" v-on:click="menuClose"><a><router-link to="/community">Community</router-link></a></li>
                <!--<li class="nav-item" v-on:click="menuClose"><a><router-link to="/trivia">Trivia</router-link></a></li>
                <li class="nav-item" v-on:click="menuClose"><a><router-link to="/socialwall">Social Wall</router-link></a></li>-->
                <li class="nav-item" v-on:click="menuClose"><a><router-link to="/eventsurvey">Event Survey</router-link></a></li>
                <li class="nav-item" v-on:click="menuClose"><a @click="zeTrigger"><router-link to="">Help Desk</router-link></a></li>
                <li class="nav-item" v-on:click="menuClose"><a><router-link to="/FAQ">FAQ</router-link></a></li>
                <!-- PARTH!! -->
                <li class="nav-item"><a @click="logout">Logout</a></li>
            </div>
        </ul>

    </div>

</template>





<script>
    import headerlogo from "../assets/logo.png"
    import accounticon from "../assets/accounticon.png"

    export default {
        name: "Header",
        data () {
            return {
                headerlogo, accounticon,
                userId : localStorage.getItem('user_id'),
                ticketNumber : localStorage.getItem('ticketNumber')
            }
        },
        methods: {
            logout(){
                localStorage.removeItem("magicLink");
                localStorage.removeItem("ticketId");

                window.location.reload()


            },
            /*Trigger for Mobile Menu to open/close*/
            menuTrigger: function () {
                var mobilemenu = document.getElementById("mobilemenu");
                if (mobilemenu.style.display == "block") {
                    mobilemenu.style.display = "none";
                } else {
                    mobilemenu.style.display = "block";
                }
                
            },
            menuClose: function () {
                var mobilemenu = document.getElementById("mobilemenu");
                if (mobilemenu.style.display == "block") {
                    mobilemenu.style.display = "none";
                } 
            },
            zeTrigger: function () {
                this.$zendesk.show();
                this.$zendesk.open();
            }
        },
        
        created () {
            let userID = localStorage.getItem('user_id');

            this.$ga.set({'dimension1': userID})
            this.$ga.set({'user_id': userID})

            console.log("user_id"+ userID);
        }
    }

</script>






<style scoped>

    /*Load Font*/
    @font-face {
        font-family: guardianfont;
        src: url(../fonts/GuardianSansRegular.otf);
    }

    header {
        height: 80px;
        width: 100%;
        background: #005F4B;
        position: sticky;
        top: 0;

        display: flex;
        flex-direction: row;
        justify-content: center;
        align-content: center;
        align-items: center;

        z-index: 1000;
    }

    nav {
        display: flex;
    }

    .leftnav {
        display: flex;
        justify-content: space-evenly;
        align-content: center;
        align-items: center;
    }
    
    /* Hamburger Menu */
    #menuToggle {
        display: none;
    }

    #mobilemenu {
        display: none;
    }

    /* Desktop to Mobile Break */
    @media only screen and (max-width: 1200px) {

        .mainmenu {
            display: none;
        }
        
        #menuToggle {
            display: block;
            position: absolute;
            top: 35%;
            left: 90%;
            z-index: 1;
            -webkit-user-select: none;
            user-select: none;
            cursor: pointer;
        }

        #menuToggle a {
            text-decoration: none;
            transition: color 0.3s ease;
            color: #ffffff;
            font-family: guardianfont;
            font-size: 16px;
            line-height: 40px;
            text-align: center;
        }

        #menuToggle a:hover {
            color: #93ea20;
        }

        #menuToggle input {
            display: block;
            width: 37px;
            height: 50px;
            position: absolute;
            top: -15px;
            left: -5px;
            cursor: pointer;
            opacity: 0; /* hide this */
            z-index: 9999; /* and place it over the hamburger */
            -webkit-touch-callout: none;
        }

        /* Just a quick hamburger */
        #menuToggle span {
            display: block;
            width: 33px;
            height: 4px;
            margin-bottom: 5px;
            position: relative;
            background: #ffffff;
            border-radius: 3px;
            z-index: 9999;
            transform-origin: 4px 0px;
            transition: transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0),
                background 0.5s cubic-bezier(0.77,0.2,0.05,1.0),
                opacity 0.55s ease;
        }

        #menuToggle span:first-child{
            transform-origin: 0% 0%;
        }

        #menuToggle span:nth-last-child(2) {
            transform-origin: 0% 100%;
        }

        /* Transform all the slices of hamburger into a crossmark.*/
        #menuToggle input:checked ~ span {
            opacity: 1;
            transform: rotate(-45deg) translate(-2px, -1px);
            background-color: #93ea20;
        }

        /* But let's hide the middle one. */
        #menuToggle input:checked ~ span:nth-last-child(2) {
            opacity: 0;
            transform: rotate(0deg) scale(0.2, 0.2);
        }

        #menuToggle input:checked ~ span:nth-last-child(3) {
            transform: rotate(45deg) translate(1px, 1px);
        }

        #mobilemenu {
            display: none;
            position: absolute;
            z-index: 100;
            width: 100%;
            height: 100%;
            margin: 0;
            padding: 0;
            list-style-type: none;
            background-color: #005f4b;
            -webkit-font-smoothing: antialiased;
            /* to stop flickering of text in safari */
        }

        .mobilelist {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-content: center;
            align-items: center;
        }

        #mobilemenu a {
            text-decoration: none;
            color: #ffffff;
            font-family: guardianfont;
            font-size: 20px;
            line-height: 50px;
        }

        #mobilemenu li {
            display: inline-block;
            list-style-type: none;
            position: relative;
            border-bottom: #ffffff 1px solid;
            padding: 7px;
            width: 50%;
            text-align: center;
        }
    }



    .headerlogo {
        width: 240px;
        padding: 10px;
    }

    nav .mainmenu {
        width: 100%;
        height: 12px;
    }

    nav .mainmenu a {
        text-decoration: none;
        color: #ffffff;
        font-family: guardianfont;
        font-size: 18px;
        line-height: 25px;
        text-align: center;
        margin: 30px 0;
        padding: 15px;
        cursor: pointer;
    }

    nav li {
        display: inline-block;
        list-style-type: none;
        position: relative;
    }

    nav .dropdown {
        display: none;
        position: absolute;
    }

    nav .dropdown a {
        text-decoration: none;
        color: #ffffff;
        font-family: guardianfont;
        font-size: 16px;
        line-height: 40px;
        text-align: center;
    }

    nav li:hover > ul {
        display: block;
        top: 100%;
        width: 180px;
        padding: 30px 0 30px 0;
        background-color: #005F4B;
        color: #93ea20;
    }

    .rightnav {
        display: flex;
        justify-content: space-evenly;
        align-content: center;
        align-items: center;
    }

    .accounticon {
        width: 30px;
        margin-left: 50px;
        padding: 5px;
    }


    /*Hovers*/
    #mobilemenu li:hover {
        background-color: #ffffff25;
    }

    nav .mainmenu a:hover, #mobilemenu a:hover {
        color: #93ea20;
        cursor: pointer;
    }

</style>